import { useMutation, useQueryClient } from '@tanstack/react-query';
import { usePrismAuth } from '@/lib/prism-bridge';
import { registerApp, type RegisterAppRequest, type RegisteredApp } from './apps';
import { queryKeys } from './queryKeys';

/**
 * Registers a new app via POST /dev-portal/apps. On success, invalidates the apps
 * list so the new app shows up. Errors surface to the caller (e.g. 409 = app id
 * already taken, 400 = invalid fields).
 */
export function useRegisterApp() {
  const { token, orgId } = usePrismAuth();
  const queryClient = useQueryClient();

  return useMutation<RegisteredApp, Error, RegisterAppRequest>({
    mutationFn: (body) => registerApp({ token, orgId }, body),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.apps.list(orgId) });
    },
  });
}
